module.exports = __webpack_public_path__ + "img/bookings_icon.dc16634f.svg";